module.exports = __webpack_public_path__ + "img/logo-ALCP.95e27d2e.svg";